export const Fifth = (props) => {

  if (props.href) {
    return (
      <a
        href={props.href}
        aria-label={props["aria-label"]}
        className="w-full text-lg flex justify-center py-2 px-4 border border-transparent rounded-full font-semibold text-tdark tracking-tight bg-purpleLight transition duration-300 hover:bg-purple hover:text-white focus:outline-hidden"
        style={{ cursor: "pointer" }}
      >
        <div className="flex">
          {props.text}
          <div className="grid content-center pl-2">{props.icon}</div>
        </div>
      </a>
    );
  }

  return (
    <div>
      <button
        onClick={props.onClick ?? null}
        type={props.type ?? "submit"}
        className="w-full text-lg flex justify-center py-2 px-4 border border-transparent rounded-full font-semibold text-tdark tracking-tight bg-purpleLight transition duration-300 hover:bg-purple hover:text-white focus:outline-hidden"
        style={{ cursor: "pointer" }}
      >
        <div className="flex">
          {props.text}
          <div className="grid content-center pl-2">{props.icon}</div>
        </div>
      </button>
    </div>
  );
};
